import React from 'react'
import ContentModelsComponent from "../components/ContentModelsComponent";


export default function ContentModels() {
  return (
    <ContentModelsComponent/>
  )
}
